module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1225.20bf8e30.png";